<div class="flex-row justify-content-space-between align-items-center">
  <h2 mat-dialog-title>My Layers</h2>

  @if (hasMapSettingsAccess$ | async) {
    <div class="mr-15">
      <button mat-icon-button
              [matTooltip]="'Edit Custom Layers Globally'"
              (click)="goToMapSettings()"
      >
        <mat-icon>open_in_new</mat-icon>
      </button>
    </div>
  }
</div>

<mat-dialog-content class="mat-typography">
  @for (mapLayer of mapLayers; track $index) {
    <mat-divider></mat-divider>
    <div class="flex-row align-items-center px-16 py-8">
      <div class="flex-grow-1">{{ mapLayer.name }}</div>

      <mat-slide-toggle [hideIcon]="true"
                        matTooltip="Toggle layer to be visible in switcher"
                        (change)="onToggleChange(mapLayer, $event)"
                        [checked]="!!visibleLayerIdMap.get(mapLayer.id)">
      </mat-slide-toggle>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close cdkFocusInitial>
    Done
  </button>
</mat-dialog-actions>


